import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'collectCharges',
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      keyColumn: 'date',
      chargesCols: []
    };
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('collect_charges_updated', this.init);
    this.fillChargesCols();
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
      });
    },
    getData() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: this.dataObj.appKey
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/CollectChargesActivity/GetData', parameter),
        (response) => {
          this.dataObj.charges = response.data.item.charges;
          this.dataObj.canContinue = response.data.item.canContinue;
          this.dataObj.total = response.data.item.total;
          this.dataObj.isAllowCollectReceipts = response.data.item.isAllowCollectReceipts;
        },
        (err) =>
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text)
      );
    },
    fillChargesCols() {
      this.chargesCols.push({
        dataField: 'date',
        caption: this.$t('activities.date'),
        dataType: 'date',
        formatData: this.$options.filters.formatDateDDMMYYY
      });
      this.chargesCols.push({ dataField: 'text', caption: this.$t('activities.documentReference') });
      this.chargesCols.push({ dataField: 'amount', caption: this.$t('activities.amount') });
    },
    goToReceipting() {
      //console.log('goToReceipting', `${window.location.origin}/receipting`);
      window.open(`${window.location.origin}/receipting`, '_blank').focus();
    }
  }
};
